import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import styles from "../../styles/components/rejectedvideotable.module.scss";
import React from "react";
import EyeTableIcon from "../../public/assets/icons/EyeTableIcon";
import thumb1 from "../../public/assets/images/tab_thumbnail_1.jpg";
import thumb2 from "../../public/assets/images/tab_thumbnail_2.jpg";
import thumb3 from "../../public/assets/images/tab_thumbnail_3.jpg";
import thumb4 from "../../public/assets/images/tab_thumbnail_4.jpg";
import thumb5 from "../../public/assets/images/tab_thumbnail_5.jpg";
import thumb6 from "../../public/assets/images/tab_thumbnail_6.jpg";
import thumb7 from "../../public/assets/images/tab_thumbnail_7.jpg";
import thumb8 from "../../public/assets/images/tab_thumbnail_8.jpg";
import thumb9 from "../../public/assets/images/tab_thumbnail_9.jpg";
import thumb10 from "../../public/assets/images/tab_thumbnail_10.jpg";
import thumb11 from "../../public/assets/images/tab_thumbnail_11.jpg";
import thumb12 from "../../public/assets/images/tab_thumbnail_12.jpg";
import thumb13 from "../../public/assets/images/tab_thumbnail_13.jpg";
import thumb14 from "../../public/assets/images/tab_thumbnail_14.jpg";
import thumb15 from "../../public/assets/images/tab_thumbnail_15.jpg";
import thumb16 from "../../public/assets/images/tab_thumbnail_16.jpg";
import thumb17 from "../../public/assets/images/tab_thumbnail_17.jpg";
import thumb18 from "../../public/assets/images/tab_thumbnail_18.jpg";
import thumb19 from "../../public/assets/images/tab_thumbnail_19.jpg";
import thumb20 from "../../public/assets/images/tab_thumbnail_20.jpg";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { TablePagination } from "@material-ui/core";
import EmptyTable from "../EmptyTable/EmptyTable";
import NoResultTable from "../NoResultTable/NoResultTable";
import NoDataIcon from "../../public/assets/icons/NoDataIcon";
import ErrorTableIcon from "../../public/assets/icons/ErrorTableIcon";
import ErrorTableIconTwo from "../../public/assets/icons/ErrorTableIconTwo";
import { useState } from "react";
import ApiLoader from "../Loaders/ApiLoader";
import {
  getAbsoluteImageURI,
  getUtcDate,
  getUtcTime,
} from "../../lib/functions/utils.lib";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";
import Pagination from "../UtilitiesComponent/Pagination";

export default function RejectedVideoTable({
  managerVideos,
  managerVideosIsSuccess,
  managerVideosIsLoading,
  calanderDate,
  handlePageChange,
  filterParams,
  videoCountry,
  resetFilterparams,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  const [id, setId] = useState();

  console.warn("rejectedId manager", id);

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
  };
  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };
  return (
    <TableContainer className={styles.tableMain}>
      <ApiLoader
        loading={
          managerVideosIsLoading &&
          !(
            managerVideosIsSuccess ||
            managerVideos?.data?.data?.length ||
            filterParams !== null ||
            videoCountry.length
          )
        }
      />
      <Table aria-label="simple table" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell className={styles.vsid}>VSID</TableCell>
            <TableCell className={styles.acqui}>Acquisitor</TableCell>
            <TableCell className={styles.thumb}>Thumbnail</TableCell>
            <TableCell className={styles.title}>title</TableCell>
            <TableCell className={styles.submitter}>Submitter Name</TableCell>
            <TableCell className={styles.email}>Email Address</TableCell>
            <TableCell className={styles.youtube}>Submission Date</TableCell>
            <TableCell className={styles.publish}>
              Awaiting Verification Since
            </TableCell>
            <TableCell className={styles.view} align="center">
              View
            </TableCell>
          </TableRow>
        </TableHead>
        {managerVideosIsLoading &&
        !(
          managerVideosIsSuccess ||
          managerVideos?.data?.data?.length ||
          filterParams !== null ||
          calanderDate.from ||
          calanderDate.to ||
          videoCountry.length
        ) ? (
          ""
        ) : managerVideos?.data?.data?.length ? (
          <TableBody>
            {managerVideos?.data?.data?.map((row, index) => (
              <>
                <TableRow key={index} className={styles.tableActive}>
                  <TableCell className={styles.vsid}>
                    <Box className={styles.vsidBox}>{row?.vsid}</Box>
                  </TableCell>
                  <TableCell className={styles.acqui}>
                    <Box className={styles.acquiBox}>
                      {row?.buyer
                        ? `${row?.buyer.name} ${row?.buyer.last_name}`
                        : "-"}
                    </Box>
                  </TableCell>
                  <TableCell className={styles.thumb}>
                    <img
                      onClick={() => onOpenTwo(row?.id)}
                      src={getAbsoluteImageURI(row?.thumbnail)}
                      width={73}
                      height={46}
                      alt="image"
                      className={styles.thumbImg}
                    />
                  </TableCell>
                  <TableCell className={styles.title}>
                    <Box className={styles.titleBox}>
                      {row?.title
                        ? row?.title?.length > 20
                          ? row.title.slice(0, 17) + "..."
                          : row.title
                        : "-"}
                    </Box>
                  </TableCell>
                  <TableCell className={styles.submitter}>
                    {`${row?.first_name} ${row?.last_name}`}
                  </TableCell>
                  <TableCell className={styles.email}>
                    {row?.email ? row?.email : "-"}
                  </TableCell>
                  <TableCell className={styles.youtube}>
                    <Typography variant="body1">
                      {getUtcDate(row?.created_at)}
                      <br /> {getUtcTime(row?.created_at)}
                    </Typography>
                  </TableCell>
                  <TableCell className={styles.publish}>
                    <Typography variant="body1">
                      {getUtcDate(row?.video_meta?.manager_updated_at)}
                      <br /> {getUtcTime(row?.video_meta?.manager_updated_at)}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" className={styles.view}>
                    <Box className={styles.viewIcon}>
                      <Button onClick={() => onOpen(row?.id)}>
                        <EyeTableIcon />
                      </Button>
                    </Box>
                  </TableCell>
                  {row?.viewBy ? (
                    <>
                      <TableCell className={styles.tdOverlay}>
                        <p>
                          This rejected video is currently being verified by
                          Admin.
                        </p>
                      </TableCell>
                    </>
                  ) : null}
                </TableRow>
                <TableRow className={styles.blnkTd}>
                  <TableCell colSpan={9}>{""}</TableCell>
                </TableRow>
              </>
            ))}
            {managerVideos?.data?.data?.length &&
            managerVideos?.data.current_page &&
            managerVideos?.data.last_page ? (
              managerVideos?.data.current_page ===
              managerVideos?.data.last_page ? (
                <TableRow className={`${styles.endOfList} ${styles.nonHover}`}>
                  <TableCell
                    // className={`${styles.no_data_found} ${styles.no_data_found_four}`}
                    colSpan={9}
                  >
                    <Box className={`${styles.no_data_div} `}>
                      <Typography variant="body1">
                        End of list. We couldn't find more approved videos
                        within the specified date range.
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                ""
              )
            ) : (
              ""
            )}

            <TableRow className={styles.paginationTble}>
              <TableCell colSpan={9} sx={{ border: "none !important" }}>
                {managerVideos?.data?.data?.length ? (
                  <Pagination
                    page={managerVideos?.data?.current_page}
                    lastpage={managerVideos?.data?.last_page}
                    onClick={handlePageChange}
                    sendDataToParent={handlePageChange}
                  />
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        ) : filterParams !== null ? (
          <TableBody>
            <TableRow>
              <TableCell className={`${styles.no_data_found}`} colSpan={9}>
                <Box className={styles.no_data_div}>
                  <figure className={styles.no_data_icon}>
                    <NoDataIcon />
                  </figure>
                  <Typography variant="body1">
                    We couldn’t find any matches for the selected filter(s).
                  </Typography>
                  <Box className={styles.btn_holder}>
                    <Button
                      type="button"
                      className={styles.reset_btn}
                      onClick={resetFilterparams}
                    >
                      Reset filters
                    </Button>
                  </Box>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : calanderDate?.from || calanderDate?.to ? (
          <TableBody>
            <TableRow>
              <TableCell
                className={`${styles.no_data_found} ${styles.no_data_found_two}`}
                colSpan={9}
              >
                <Box className={styles.no_data_div}>
                  <figure className={styles.no_data_icon}>
                    <ErrorTableIcon />
                  </figure>
                  <Typography variant="body1">
                    We couldn't find any videos approved within the specified
                    date range.
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell
                className={`${styles.no_data_found} ${styles.no_data_found_three}`}
                colSpan={9}
              >
                <Box className={styles.no_data_div}>
                  <figure className={styles.no_data_icon}>
                    <ErrorTableIconTwo />
                  </figure>
                  <Typography variant="body1">
                    You have no approved videos at the moment. Please start
                    reviewing videos.
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
      <VideoPageFullModal
        onClose={onClose}
        open={openModal}
        id={id}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
      <WatchVideoModal
        onClose={onCloseTwo}
        open={openModalTwo}
        id={id}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
    </TableContainer>
  );
}
